import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


import {
  TextField,
  Button,
  IconButton,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
} from "@mui/material";
import { loginUser } from "../../Components/Helpers/API/AuthApi";
import { toast } from "react-toastify";
import { refreshPage } from "../../Helpers/Utils/Common";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import background from "../../Assets/Images/login_background.png";
import emr from "../../Assets/Images/product-emr-final-logo.png";

import packageJson from "../../../package.json";
import "./Login.css";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Show Password function
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Login Button Api Call
  async function submit() {
    setIsLoading(true);
    const response = await loginUser(username, password);
    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data.user_id));
      localStorage.setItem(
        "full_name",
        JSON.stringify(response.data.full_name)
      );
      localStorage.setItem("role_id", JSON.stringify(response.data.role_id));
      localStorage.setItem("role", JSON.stringify(response.data.role_name));
      localStorage.setItem(
        "token",
        JSON.stringify(response.data.token).replace(/['"]+/g, "")
      );
      toast.success(response.data.message);
      setTimeout(() => {
        handleNavigation(response.data.role_name);
      }, 1000);
    } else if (response.error) {
      toast.error(response.error.data.messages.error_messages.message);
      // response.error.data.messages.error_messages.map((data) => (
      //   toast.error(data)
      // ))
    }
    setIsLoading(false);
  }

  // trigger login when enter button is clicked
  const handleKeyPress = (event) => {
    // Check if the pressed key is Enter (key code 13)
    if (event.key === "Enter") {
      // Trigger the button click event
      submit();
    }
  };

  function handleNavigation(role) {
    if (role === "laboratory") {
      navigate("/patients");
      refreshPage();
    } else {
      navigate("/dashboard");
      refreshPage();
    }
  }

  return (
    <Row className="page">
      <Col xs={6} className="center col-logo-left mt-5">
        <img src={background} className="logo-left-v2 mt-5 ml-5" alt="logo" />
      </Col>
      <Col xs={6} className="col-logo-right mt-5 ">
        <Row className="page-inputs mt-5">
          <Col className="center mt-5">
            <img src={emr} className="logo-right" alt="logo" />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <Row className="center">
              <TextField
                size="small"
                disabled={isLoading}
                sx={{ m: 1, width: "25vw" }}
                label="Username"
                variant="outlined"
                className="user-input"
                color="primary"
                fullWidth
                required
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={handleKeyPress}
              />
            </Row>
            <Row className="center">
              <FormControl
                sx={{ m: 1, width: "25vw" }}
                size="small"
                variant="outlined"
                className="password-input"
                onKeyDown={handleKeyPress}
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Password *
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  disabled={isLoading}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {/* {showPassword ? <VisibilityOff /> : <Visibility />} */}
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
            </Row>
          </Col>
        </Row>
        <Row>
          <Row style={{ marginTop: -6, marginBottom: 6 }}>
            <div
              style={{
                width: "100%",
                fontSize: "12px",
                color: "#999",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              v{packageJson.version}
            </div>
          </Row>
          <Col className="center">
            <Button
              disabled={isLoading}
              className="login-btn"
              size="large"
              variant="contained"
              onClick={() => submit()}
            >
              {isLoading ? `Logging in...` : `Login`}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Login;
